import React from "react";
import { Link } from "react-router-dom";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import DirectionsCarOutlinedIcon from "@mui/icons-material/DirectionsCarOutlined";
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import "./Home.css";

const loanDetails = [
  {
    name: "Personal Loan",
    path: "/personal-loan",
    icon: AccountBalanceWalletOutlinedIcon,
    description: "Unsecured funding for medical needs, travel, or weddings — no collateral required.",
  },
  {
    name: "Vehicle Loan",
    path: "/vehicle-loan",
    icon: DirectionsCarOutlinedIcon,
    description: "Competitive rates and flexible tenures for new and used vehicles.",
  },
  {
    name: "Business Loan",
    path: "/business-loan",
    icon: BusinessOutlinedIcon,
    description: "Working capital and growth funding through leading banks and NBFCs.",
  },
  {
    name: "Home Loan",
    path: "/home-loan",
    icon: HomeOutlinedIcon,
    description: "Long-tenure home finance with guidance from purchase to disbursal.",
  },
  {
    name: "Loan Against Property",
    path: "/contact",
    icon: AccountBalanceOutlinedIcon,
    description: "Unlock property value for expansion, education, or large expenses.",
  },
  {
    name: "Education Loan",
    path: "/contact",
    icon: SchoolOutlinedIcon,
    description: "Support for studies in India and abroad with structured repayment options.",
  },
];

const pillars = [
  { title: "Bank & NBFC network", description: "Access offers from 10+ RBI-registered lending partners." },
  { title: "Digital journey", description: "Check eligibility and compare estimates in minutes." },
  { title: "Zero customer fees", description: "Our assistance is free — lenders handle disbursal directly." },
  { title: "Dedicated guidance", description: "Documentation and application support from enquiry to offer." },
];

const Home = () => {
  return (
    <main className="home-page">
      <section className="hero-banner">
        <div className="hero-overlay" />
        <div className="hero-content cb-container">
          <p className="hero-brand cb-rise">Core Bankers</p>
          <h1 className="hero-title cb-rise cb-rise-delay">
            Finance matched to your profile — not a one-size offer.
          </h1>
          <p className="hero-subtitle cb-rise cb-rise-delay-2">
            An RBI-compliant DSA under VedhaNirvana Private Limited, connecting you with banks and NBFCs for clearer, faster loan decisions.
          </p>
          <div className="hero-actions cb-rise cb-rise-delay-2">
            <Link to="/eligibility" className="cb-btn">
              Check Eligibility
            </Link>
            <Link to="/about" className="cb-btn cb-btn-ghost">
              About Core Bankers
            </Link>
          </div>
        </div>
      </section>

      <section className="solutions-section">
        <div className="cb-container">
          <header className="section-header">
            <span className="cb-section-label">Solutions</span>
            <h2 className="cb-section-title">Loan products we facilitate</h2>
            <p className="cb-section-lead">
              Personal, property, vehicle, and business finance — matched to lenders that fit your profile.
            </p>
          </header>

          <div className="solutions-grid">
            {loanDetails.map((loan) => {
              const Icon = loan.icon;
              return (
                <Link to={loan.path} key={loan.name} className="solution-item">
                  <span className="solution-icon" aria-hidden="true">
                    <Icon fontSize="inherit" />
                  </span>
                  <div>
                    <h3>{loan.name}</h3>
                    <p>
                      {loan.description}
                      <span className="solution-arrow">Explore</span>
                    </p>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </section>

      <section className="trust-section">
        <div className="cb-container trust-layout">
          <div className="trust-copy">
            <span className="cb-section-label">Why Core Bankers</span>
            <h2 className="cb-section-title">Your advocate across lenders</h2>
            <p>
              We do not lend. As a Direct Selling Agent, we review options across partner banks and NBFCs so you understand rates, eligibility, and documentation before you apply.
            </p>
          </div>
          <div className="trust-grid">
            {pillars.map((item) => (
              <article key={item.title} className="trust-card">
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="home-cta-section">
        <div className="cb-container home-cta-inner">
          <div>
            <h2>Ready to see your options?</h2>
            <p>Get an estimated eligibility in a few minutes — free, with no obligation.</p>
          </div>
          <Link to="/eligibility" className="cb-btn">
            Check Eligibility
          </Link>
        </div>
      </section>
    </main>
  );
};

export default Home;
